export const getPourcentageIndicator = (firstNumber, secondNumber) => {

    const prev = Number(firstNumber) || 0;
    const curr = Number(secondNumber) || 0;

    let pctChangeDisplay = '0%';
    let pct = 0;

    if (prev === 0) {
        if (curr === 0) {
            pctChangeDisplay = '0%';
            pct = 0;
        } else {
            pctChangeDisplay = '∞%';
            pct = Infinity;
        }
    } else {
        pct = ((curr - prev) / prev) * 100;
        pctChangeDisplay = `${pct >= 0 ? '+' : ''}${pct.toFixed(0)}%`;
    }

    const pctColor = pct > 0 ? '#D32F2F' : pct < 0 ? '#2E7D32' : '#6B6B6B';
    const arrow = pct > 0 ? '▲' : pct < 0 ? '▼' : '•';

    return { pctChangeDisplay, pctColor, arrow };
}